module.exports = __webpack_public_path__ + "img/empty_image.7c2534d3.png";